import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

const handleSpacing = level => {
	switch (level) {
		case 1:
			return '0';
		case 2:
			return '0 0 0 10px';
		case 3:
			return '0 0 0 20px';
		case 4:
			return '0 0 0 30px';
		default:
			return '0';
	}
};

export const Content = styled.div`
	vertical-align: middle;
`;

export const TableRow = styled.tr`
	transition: all 0.3s linear 0s;
	position: ${props =>
		(props.group === 1 || props.group === 2) &&
		props.level === 1 &&
		!props.isFirstTab &&
		'sticky'};
	top: ${props =>
		(props.group === 1 || props.group === 2) && props.level === 1 && '46px'};
	z-index: ${props =>
		(props.group === 1 || props.group === 2) && props.level === 1 && '11'};
	background: ${props =>
		props.isChildOfExpanded ? colors.grey100 : colors.grey200};
	border-bottom: 1px solid #d4d4d4;
`;

export const TableCellGroup = styled.td`
	padding: 20px 0 20px 7px;
	vertical-align: middle;
`;

export const TableCellPeerCount = styled.td`
	width: 8%;
	padding: 0 5px 0;
	text-align: center;
`;

export const TableCellMin = styled.td`
	width: 8%;
	padding: 0 5px 0;
	text-align: center;
`;

export const TableCellLoader = styled.td`
	width: 100%;
	padding: 0 5px 0;
`;

export const TableCellChart = styled.td`
	width: 42%;
	padding: 0 5px 0;
	overflow: hidden;
`;

export const TableCellMax = styled.td`
	width: 8%;
	padding: 0 5px 0;
	text-align: center;
`;

export const TableCellGroupDiv = styled.div`
	width: 100%;
	display: flex;
	justify-content: start;
	transition: all 1s ease-in-out;
	padding: ${({ level }) => handleSpacing(level)};

	button {
		visibility: ${({ level, isFirstTab, hasChildren }) =>
			((!isFirstTab && level === 4) ||
				(isFirstTab && (level !== 1 || !hasChildren))) &&
			'hidden'};
	}
`;

export const ToggleButton = styled.button`
	border: none;
	padding: 0;
	height: 20px;
	cursor: pointer;
	&:hover {
		svg {
			fill: #5cb335;
		}
	}
`;

export const Label = styled.label`
	font-size: 15px;
`;

export const SelectedTopBox = styled.div`
	background-color: ${props => (props.$showMarker ? '#5cb335' : 'black')};
	color: white;
	height: auto;
	font-size: 0.85rem;
	padding: 0.5rem;
	text-align: left;
	font-family: sans-serif;
	width: 100%;
	padding-top: 0.4rem;
	padding-left: 0.3rem;
	border-top-right-radius: 3px;
	border-top-left-radius: 3px;
	display: flex;
	box-sizing: border-box;
`;

export const SlectedPercentageBox = styled.div`
	background-color: #80808052;
	color: black;
	height: auto;
	font-size: 0.9rem;
	border-bottom-right-radius: 3px;
	text-align: center;
	border-bottom-left-radius: 3px;
	padding: 0.5rem;
	font-weight: bold;
	width: 100%;
	box-sizing: border-box;
`;

export const SelectionBoxContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 9.5rem;
	max-width: 100%;
	border: 1px solid #d4d4d4;
	border-radius: 3px;
	box-sizing: border-box;
	margin: 0.5rem;
`;

export const LinearGuageContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	box-sizing: border-box;
`;
